// Comprehensive country list
export const ALL_COUNTRIES = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Argentina", "Armenia", "Australia",
  "Austria", "Azerbaijan", "Bahrain", "Bangladesh", "Belarus", "Belgium", "Bolivia",
  "Bosnia and Herzegovina", "Brazil", "Brunei", "Bulgaria", "Cambodia", "Cameroon", "Canada",
  "Chile", "China", "Colombia", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic",
  "Denmark", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Estonia", "Ethiopia",
  "Finland", "France", "Georgia", "Germany", "Ghana", "Greece", "Guatemala", "Honduras",
  "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel",
  "Italy", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kuwait", "Kyrgyzstan", "Laos", "Latvia",
  "Lebanon", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Malaysia", "Maldives", "Malta",
  "Mexico", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Myanmar", "Nepal",
  "Netherlands", "New Zealand", "Nigeria", "North Macedonia", "Norway", "Oman", "Pakistan",
  "Palestine", "Panama", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar",
  "Romania", "Russia", "Rwanda", "Saudi Arabia", "Senegal", "Serbia", "Singapore", "Slovakia",
  "Slovenia", "South Africa", "South Korea", "Spain", "Sri Lanka", "Sudan", "Sweden",
  "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Tunisia", "Turkey",
  "Turkmenistan", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States",
  "Uruguay", "Uzbekistan", "Venezuela", "Vietnam", "Yemen", "Zimbabwe",
];

export const CIVIL_STATUSES = ["Single", "Married", "Registered Partnership", "Separated", "Divorced", "Widow(er)", "Other"];
export const SEX_OPTIONS = ["Male", "Female", "Other"];
export const TRAVEL_DOC_TYPES = ["Ordinary passport", "Diplomatic passport", "Service passport", "Official passport", "Special passport", "Other"];
export const PURPOSE_OPTIONS = ["Tourism", "Business", "Visiting family or friends", "Cultural", "Sports", "Official visit", "Medical reasons", "Study", "Airport transit", "Other"];
export const RELATIONSHIP_OPTIONS = ["Self", "Spouse", "Child", "Parent", "Other"];
export const EU_RELATIONSHIP_OPTIONS = ["Spouse", "Child", "Parent", "Grandparent", "Grandchild", "Other"];
export const ENTRIES_OPTIONS = ["Single entry", "Two entries", "Multiple entries"];
export const OCCUPATIONS = [
  "Employed", "Self-employed", "Business owner", "Student", "Retired",
  "Homemaker", "Unemployed", "No occupation", "Other",
];
export const COST_COVERED_OPTIONS = [
  "Applicant himself/herself", "Sponsor (host, company, organisation)",
  "Inviting person", "Other",
];
export const MEANS_OF_SUPPORT_OPTIONS = [
  "Cash", "Traveller's cheques", "Credit card", "Pre-paid accommodation",
  "Pre-paid transport", "Other",
];

export const STEPS = [
  { key: "passport", label: "Passport Details" },
  { key: "application", label: "Application Details" },
  { key: "travel", label: "Travel Details" },
  { key: "additional", label: "Additional Details" },
];

export function isMinor(dateOfBirth) {
  if (!dateOfBirth) return false;
  const dob = new Date(dateOfBirth);
  if (isNaN(dob.getTime())) return false;
  const now = new Date();
  let age = now.getFullYear() - dob.getFullYear();
  const m = now.getMonth() - dob.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < dob.getDate())) age--;
  return age < 18;
}

export function emptyApplicant() {
  return {
    // stable client-side id used only for React keys (not persisted server-side)
    _uid: (typeof crypto !== "undefined" && crypto.randomUUID)
      ? crypto.randomUUID()
      : `a_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`,
    // Step 1 — Passport Details
    surname: "", surname_at_birth: "", first_names: "",
    date_of_birth: "", country_of_birth: "", place_of_birth: "",
    nationality: "", nationality_at_birth: "", nationality_other: "",
    sex: "", civil_status: "",
    minor_applicant: "",
    applicant_id_number: "",
    travel_document_type: "Ordinary passport",
    passport_number: "", passport_number_confirm: "",
    passport_issue_date: "", passport_issued_country: "",
    passport_expiry_date: "", passport_issued_by_authority: "",
    // Step 2 — Application Details
    home_address: "", application_street: "", application_city: "",
    applicant_country: "", applicant_postal_code: "",
    occupation: "", occupation_other: "", email: "", phone: "",
    residence_different: "", residence_country: "", residence_permit_no: "", residence_permit_valid_until: "",
    employer_name: "", employer_address: "", employer_phone: "",
    employer_city: "", employer_postal_code: "", employer_country: "",
    fingerprints_collected: "", fingerprints_date: "",
    fingerprints_sticker_country: "", fingerprints_sticker_number: "",
    // Step 3 — Travel Details
    purpose: "", purpose_additional_info: "",
    first_entry_country: "",
    destination_countries: [],
    destination_nights: [],
    intended_arrival_date: "", intended_departure_date: "",
    number_of_entries: "",
    previous_visa_3y: "", previous_visa_validity_from: "", previous_visa_validity_until: "",
    travel_insurance_ack: "",
    // Step 4 — Additional Details
    cost_covered_by: "", cost_covered_by_other: "",
    means_of_support: [], means_of_support_other: "",
    has_eu_family: "",
    eu_family_surname: "", eu_family_first_name: "", eu_family_nationality: "",
    eu_family_dob: "", eu_family_passport: "", eu_family_relationship: "", eu_family_relationship_other: "",
    inviting_costs: "", inviting_covered_by: "",
    // Within-order relationship + Minor guardian
    relationship: "",
    guardian_name: "", guardian_address: "", guardian_phone: "", guardian_email: "", guardian_nationality: "",
  };
}

export function applicantDisplayName(a) {
  if (!a) return "";
  const ns = `${a.first_names || ""} ${a.surname || ""}`.trim();
  if (ns) return ns;
  if (a.full_name) return a.full_name;
  return "";
}

export function totalDays(arrival, departure) {
  if (!arrival || !departure) return 0;
  const a = new Date(arrival); const d = new Date(departure);
  if (isNaN(a.getTime()) || isNaN(d.getTime())) return 0;
  const days = Math.round((d - a) / (1000 * 60 * 60 * 24)) + 1;
  return days > 0 ? days : 0;
}

const STEP_REQUIRED = {
  passport: [
    "surname", "surname_at_birth", "first_names",
    "date_of_birth", "country_of_birth", "place_of_birth",
    "nationality", "nationality_at_birth", "sex", "civil_status", "minor_applicant",
    "travel_document_type", "passport_number", "passport_number_confirm",
    "passport_issue_date", "passport_issued_country", "passport_expiry_date", "passport_issued_by_authority",
  ],
  application: [
    "home_address", "application_street", "application_city", "applicant_country", "applicant_postal_code",
    "occupation", "email", "phone", "residence_different",
    "fingerprints_collected",
  ],
  travel: [
    "purpose", "purpose_additional_info",
    "first_entry_country",
    "intended_arrival_date", "intended_departure_date",
    "number_of_entries",
    "previous_visa_3y", "travel_insurance_ack",
  ],
  additional: [
    "cost_covered_by", "has_eu_family", "inviting_costs",
  ],
};

const STEP_LABELS = {
  passport: "Passport Details",
  application: "Application Details",
  travel: "Travel Details",
  additional: "Additional Details",
};

const FIELD_LABELS = {
  surname: "Surname", surname_at_birth: "Surname at birth", first_names: "First name(s)",
  date_of_birth: "Date of birth", country_of_birth: "Country of birth", place_of_birth: "Place of birth",
  nationality: "Current nationality", nationality_at_birth: "Nationality at birth",
  sex: "Sex", civil_status: "Marital status", minor_applicant: "Minor applicant",
  travel_document_type: "Type of passport", passport_number: "Passport number",
  passport_number_confirm: "Passport number (confirm)",
  passport_issue_date: "Passport date of issue", passport_issued_country: "Issued country",
  passport_expiry_date: "Passport valid until", passport_issued_by_authority: "Issued by (authority)",
  home_address: "Home address", application_street: "Street",
  application_city: "City", applicant_country: "Country", applicant_postal_code: "Postal code",
  occupation: "Current occupation", occupation_other: "Occupation (Other)",
  email: "Email", phone: "Telephone",
  residence_different: "Residence different country",
  residence_country: "Country of residence",
  residence_permit_no: "Residence permit number", residence_permit_valid_until: "Residence permit valid until",
  employer_name: "Employer name", employer_address: "Employer address", employer_phone: "Employer telephone",
  employer_city: "Employer city", employer_postal_code: "Employer postal code", employer_country: "Employer country",
  fingerprints_collected: "Fingerprints collected previously",
  fingerprints_date: "Fingerprints date",
  fingerprints_sticker_country: "Schengen country (fingerprints)",
  fingerprints_sticker_number: "Visa sticker number (fingerprints)",
  purpose: "Purpose of travel", purpose_additional_info: "Additional info on purpose",
  first_entry_country: "Schengen State of first entry",
  destination_countries: "Country(-ies) of destination",
  intended_arrival_date: "Intended arrival date",
  intended_departure_date: "Intended departure date",
  number_of_entries: "Number of entries",
  previous_visa_3y: "Previous Schengen visa (3 years)",
  previous_visa_validity_from: "Previous visa validity from",
  previous_visa_validity_until: "Previous visa validity until",
  travel_insurance_ack: "Travel insurance acknowledgement",
  cost_covered_by: "Cost covered by",
  cost_covered_by_other: "Cost covered by (Other)",
  means_of_support: "Applicant's means of support",
  means_of_support_other: "Means of support (Other)",
  has_eu_family: "EU/EEA/CH/UK family member",
  eu_family_surname: "EU family surname", eu_family_first_name: "EU family first name",
  eu_family_nationality: "EU family nationality", eu_family_dob: "EU family DOB",
  eu_family_passport: "EU family passport number",
  eu_family_relationship: "EU family relationship",
  eu_family_relationship_other: "EU family relationship (Other)",
  inviting_costs: "Costs covered by inviting party",
  inviting_covered_by: "Inviting party",
  guardian_name: "Guardian name", guardian_address: "Guardian address",
  guardian_phone: "Guardian phone", guardian_email: "Guardian email",
  guardian_nationality: "Guardian nationality",
};

function stepMissing(step, a) {
  const missing = [];
  if (!a) { return STEP_REQUIRED[step] || []; }
  // Base required fields with per-step conditional exemptions
  for (const k of STEP_REQUIRED[step] || []) {
    if (step === "travel" && k === "intended_departure_date") {
      // both arrival + departure required, departure must be >= arrival
      if (!a.intended_departure_date) missing.push(k);
      continue;
    }
    if (!a[k]) missing.push(k);
  }
  if (step === "passport") {
    if (a.passport_number && a.passport_number_confirm && a.passport_number !== a.passport_number_confirm) {
      missing.push("passport_number_confirm");
    }
    if ((a.minor_applicant === "yes") || isMinor(a.date_of_birth)) {
      for (const k of ["guardian_name", "guardian_address", "guardian_phone", "guardian_email", "guardian_nationality"]) {
        if (!a[k]) missing.push(k);
      }
    }
  }
  if (step === "application") {
    if (a.residence_different === "yes") {
      if (!a.residence_country) missing.push("residence_country");
      if (!a.residence_permit_no) missing.push("residence_permit_no");
      if (!a.residence_permit_valid_until) missing.push("residence_permit_valid_until");
    }
    if (a.occupation === "Other" && !a.occupation_other) missing.push("occupation_other");
    if (a.occupation && a.occupation !== "No occupation") {
      for (const k of ["employer_name", "employer_address", "employer_phone", "employer_city", "employer_postal_code", "employer_country"]) {
        if (!a[k]) missing.push(k);
      }
    }
    if (a.fingerprints_collected === "yes") {
      for (const k of ["fingerprints_date", "fingerprints_sticker_country", "fingerprints_sticker_number"]) {
        if (!a[k]) missing.push(k);
      }
    }
  }
  if (step === "travel") {
    if (!a.destination_countries || !a.destination_countries.length) missing.push("destination_countries");
    if (a.intended_arrival_date && a.intended_departure_date) {
      const t = totalDays(a.intended_arrival_date, a.intended_departure_date);
      if (!t) missing.push("intended_departure_date");
    }
    if (a.previous_visa_3y === "yes") {
      if (!a.previous_visa_validity_from) missing.push("previous_visa_validity_from");
      if (!a.previous_visa_validity_until) missing.push("previous_visa_validity_until");
    }
  }
  if (step === "additional") {
    if (a.cost_covered_by === "Other" && !a.cost_covered_by_other) missing.push("cost_covered_by_other");
    const means = Array.isArray(a.means_of_support) ? a.means_of_support : (a.means_of_support ? [a.means_of_support] : []);
    if (means.length === 0) missing.push("means_of_support");
    if (means.includes("Other") && !a.means_of_support_other) missing.push("means_of_support_other");
    if (a.has_eu_family === "yes") {
      for (const k of ["eu_family_surname", "eu_family_first_name", "eu_family_nationality", "eu_family_dob", "eu_family_passport", "eu_family_relationship"]) {
        if (!a[k]) missing.push(k);
      }
      if (a.eu_family_relationship === "Other" && !a.eu_family_relationship_other) missing.push("eu_family_relationship_other");
    }
    if (a.inviting_costs === "yes" && !a.inviting_covered_by) missing.push("inviting_covered_by");
  }
  return missing;
}

export function stepIsComplete(step, a) {
  return stepMissing(step, a).length === 0;
}

export function applicantIsComplete(a) {
  return ["passport", "application", "travel", "additional"].every((s) => stepIsComplete(s, a));
}

export function applicantIncompleteReason(a) {
  const out = [];
  for (const s of ["passport", "application", "travel", "additional"]) {
    const miss = stepMissing(s, a);
    if (miss.length) out.push({ step: s, stepLabel: STEP_LABELS[s], fields: miss.map((k) => FIELD_LABELS[k] || k) });
  }
  return out;
}

export function sanitizePhone(v) {
  if (v === undefined || v === null) return "";
  return String(v).replace(/[^0-9+\-\s()]/g, "");
}

export function computeOrderSummary(applicants) {
  const list = applicants || [];
  const dests = [];
  for (const a of list) {
    for (const c of (a.destination_countries || [])) if (c && !dests.includes(c)) dests.push(c);
  }
  return { destinations: dests, mainDestination: dests[0] || "", others: dests.slice(1) };
}

export function formatDestinationSummary(order) {
  const s = computeOrderSummary(order?.applicants || []);
  if (!s.mainDestination) return order?.destination_country || "—";
  return s.others.length ? `${s.mainDestination} (+${s.others.length} more)` : s.mainDestination;
}

export function formatOrderDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export function formatDateRange(order) {
  const list = order?.applicants || [];
  let earliest = null, latest = null;
  // Try previous_visa_validity range as a fallback — but really we don't track travel dates anymore. Use order fields if available.
  if (order?.travel_start_date && order?.travel_end_date) {
    return `${order.travel_start_date} → ${order.travel_end_date}`;
  }
  return "—";
}
